var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardSel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16663 0H1.16663C0.523315 0 0 0.523315 0 1.16663V4.16663C0 4.81006 0.523315 5.33337 1.16663 5.33337H6.16663C6.81006 5.33337 7.33337 4.81006 7.33337 4.16663V1.16663C7.33337 0.523315 6.81006 0 6.16663 0Z",
    fill: "url(#paint0_linear_66_596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16663 6.66663H1.16663C0.523315 6.66663 0 7.18994 0 7.83337V14.8334C0 15.4767 0.523315 16 1.16663 16H6.16663C6.81006 16 7.33337 15.4767 7.33337 14.8334V7.83337C7.33337 7.18994 6.81006 6.66663 6.16663 6.66663Z",
    fill: "url(#paint1_linear_66_596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8334 10.6666H9.83337C9.18994 10.6666 8.66663 11.1899 8.66663 11.8334V14.8334C8.66663 15.4767 9.18994 16 9.83337 16H14.8334C15.4767 16 16 15.4767 16 14.8334V11.8334C16 11.1899 15.4767 10.6666 14.8334 10.6666Z",
    fill: "url(#paint2_linear_66_596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8334 0H9.83337C9.18994 0 8.66663 0.523315 8.66663 1.16663V8.16663C8.66663 8.81006 9.18994 9.33337 9.83337 9.33337H14.8334C15.4767 9.33337 16 8.81006 16 8.16663V1.16663C16 0.523315 15.4767 0 14.8334 0Z",
    fill: "url(#paint3_linear_66_596)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_596",
    x1: 3.66669,
    y1: 0,
    x2: 3.66669,
    y2: 5.33337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_66_596",
    x1: 3.66669,
    y1: 6.66663,
    x2: 3.66669,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_66_596",
    x1: 12.3333,
    y1: 10.6666,
    x2: 12.3333,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_66_596",
    x1: 12.3333,
    y1: 0,
    x2: 12.3333,
    y2: 9.33337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSel);
export default __webpack_public_path__ + "static/media/dashboardSel.ea041b16b576c3ff864f32400c1408d3.svg";
export { ForwardRef as ReactComponent };